import { api } from "../api";

export class EmailService {

    async send_email_credenciado (payload: any) {
        return await api.post(`/send-email/credenciado`, payload, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(res => res)
        .catch(error => error);
          
    }

    async send_email_cotacao (payload: any) {
        return await api.post(`/send-email/cotacao`, payload)
        .then(res => res)
        .catch(error => error);
          
    }
    async send_email_home (payload: any) {
        return await api.post(`/send-email/home`, payload)
        .then(res => res)
        .catch(error => error);
          
    }
    
}